import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'; // this is needed!
import {RouterModule} from '@angular/router';
import {HttpModule} from '@angular/http';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatIconRegistry,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatStepperModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
} from '@angular/material';


import { environment } from '../environments/environment';

import { SocialLoginModule, AuthServiceConfig } from "angular5-social-login";
import { FacebookLoginProvider, GoogleLoginProvider } from "angular5-social-login";

import {DomSanitizer} from '@angular/platform-browser';
import {CurrencyMaskModule} from 'ng2-currency-mask';
import {CurrencyMaskConfig, CURRENCY_MASK_CONFIG} from 'ng2-currency-mask/src/currency-mask.config';

import {SortablejsModule} from 'angular-sortablejs';

import { RoundProgressModule } from 'angular-svg-round-progressbar';

import {AppComponent} from './app.component';

import {AuthLayoutComponent} from './modules/layouts/auth/auth-layout.component';
import {ClientesLayoutComponent} from './modules/layouts/clientes/clientes-layout.component';

import {AppRoutes} from './app.routing';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule, HttpHeaders} from '@angular/common/http';
import {AuthGuardService} from './services/auth-guard.service';
import {AuthService} from './services/auth.service';
import {RoleGuardService} from './services/role-guard.service';

import {DynamicFormModule} from './modules/shared/dynamic-form/dynamic-form.module';
import {VisualizadorComponent} from './modules/visualizador/visualizador.component';
import {ClientInterceptor} from './@core/interceptors/client-interceptor';
import {SmartfitPropostaService} from './services/smartfit-proposta.service';
import {ForbiddenComponent} from './modules/shared/pages/forbidden.component';

import {EditorLayoutComponent} from './modules/layouts/editor/editor-layout.component';

import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireStorageModule } from 'angularfire2/storage';
import { GlobalService } from './services/global.services';

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: 'left',
  allowNegative: false,
  allowZero: true,
  decimal: ',',
  precision: 2,
  prefix: 'R$ ',
  suffix: '',
  thousands: '.'
};

export function getAuthServiceConfigs()
{
 let config = new AuthServiceConfig([
   {
     id: FacebookLoginProvider.PROVIDER_ID,
     provider: new FacebookLoginProvider("214373356016835")
   },
   {
     id: GoogleLoginProvider.PROVIDER_ID,
     provider: new GoogleLoginProvider("690940757822-jrr093pf2qieg1rd27erh5kqokp2kcun.apps.googleusercontent.com")
   }
 ]);
   return config;
}

@NgModule({
  exports: [
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule
  ],
})
export class MaterialModule {
}

@NgModule({
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    RouterModule.forRoot(AppRoutes),
    HttpModule,
    MaterialModule,
    MatNativeDateModule,
    HttpClientModule,
    MatDatepickerModule,
    DynamicFormModule,
    SortablejsModule.forRoot({animation: 150}),
    CurrencyMaskModule,
    RoundProgressModule,
    SocialLoginModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireStorageModule
  ],
  declarations: [
    AppComponent,
    AuthLayoutComponent,
    ClientesLayoutComponent,
    VisualizadorComponent,
    ForbiddenComponent,
    EditorLayoutComponent
  ],
  bootstrap: [AppComponent],
  providers: [
    AuthGuardService,
    RoleGuardService,
    AuthService,
    SmartfitPropostaService,
    GlobalService,
    {
      provide: CURRENCY_MASK_CONFIG,
      useValue: CustomCurrencyMaskConfig
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ClientInterceptor,
      multi: true
    },
    {
       provide: AuthServiceConfig,
       useFactory: getAuthServiceConfigs
    }
  ]
})
export class AppModule {
  constructor(matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer) {
    matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl('./assets/mdi.svg'));
    // Or whatever path you placed mdi.svg at
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts